import React, { useState, useLayoutEffect, useContext } from 'react'
import styled from 'styled-components'
import PipesInput from 'live/components/events/ui/console-input'

const ConsolePipes = PipesInput()

const Pipes = styled.div`
    width: 100%;
    max-height:100%;
    overflow-y: auto;
    padding: 5px;
    border: solid 1px #c2c2c2;
`

export default function PipesForm({ onChange, query, maxHeight = '100%' }: {
    onChange: (expression: string) => void,
    query: string,
    maxHeight?: string
}) {
    return <Pipes style={{
        maxHeight: maxHeight
    }}>
        <ConsolePipes
            minHeight={50}
            maxHeight={100}
            disableFocus={true}
            lineNumbers={true}
            expression={query}
            onChangeExpression={onChange}
        />
    </Pipes>
}